module.exports = __webpack_public_path__ + "media/images/lb/030-37bd616454b5097545ba7c62d74f01bb.svg";